(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const MOBILE_HEADER_SCROLL = {
    DIRECTION_THRESHOLD: 50,
    TOP_OFFSET: 32,
    MIN_DELTA: 4,
  };

  class MobileHeaderHideOnScroll {
    constructor(header, options = {}) {
      this.header = header;
      this.getPredictiveSearches = options.getPredictiveSearches || (() => []);
      this.onHide = options.onHide || (() => {});
      this.onShow = options.onShow || (() => {});
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.currentScrollTop = window.scrollY || document.documentElement.scrollTop;
      this.scrollDirection = 0;
      this.isHidden = false;
      this.preventReveal = false;
      this.headerBounds = { top: 0, bottom: header.offsetHeight };

      this.onScroll = this.onScroll.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onPreventReveal = () => (this.preventReveal = true);
      this.onMenuDrawerToggle = this.onMenuDrawerToggle.bind(this);
    }

    connect(scrollTarget) {
      this.scrollTarget = scrollTarget;
      scrollTarget.addEventListener('preventHeaderReveal', this.onPreventReveal);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.mobileMediaQuery.addEventListener('change', this.onMediaChange);
      this.menuDrawerDetails =
        scrollTarget.querySelector('#Details-menu-drawer-container') ||
        document.getElementById('Details-menu-drawer-container');
      this.menuDrawerDetails?.addEventListener('toggle', this.onMenuDrawerToggle);
      this.observeBounds();
    }

    disconnect() {
      window.removeEventListener('scroll', this.onScroll);
      this.mobileMediaQuery.removeEventListener('change', this.onMediaChange);
      this.scrollTarget?.removeEventListener('preventHeaderReveal', this.onPreventReveal);
      this.menuDrawerDetails?.removeEventListener('toggle', this.onMenuDrawerToggle);
    }

    observeBounds() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
      });

      observer.observe(this.header);
    }

    onMediaChange() {
      if (!this.mobileMediaQuery.matches) {
        this.showHeader(true);
      }
    }

    isEnabled() {
      return this.mobileMediaQuery.matches;
    }

    isPredictiveSearchOpen() {
      return Array.from(this.getPredictiveSearches()).some((search) => search.isOpen);
    }

    isMenuDrawerOpen() {
      if (this.header?.classList.contains('menu-open')) return true;

      const menuDrawerDetails = this.menuDrawerDetails || document.getElementById('Details-menu-drawer-container');

      return Boolean(menuDrawerDetails?.open);
    }

    onMenuDrawerToggle() {
      if (!this.isEnabled() || !this.isMenuDrawerOpen()) return;

      this.showHeader(false, false);
      this.scrollDirection = 0;
    }

    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (!this.isEnabled()) {
        this.showHeader(true);
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.isMenuDrawerOpen()) {
        if (this.isHidden) this.showHeader(false, false);
        this.scrollDirection = 0;
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.isPredictiveSearchOpen()) return;

      const delta = scrollTop - this.currentScrollTop;
      if (Math.abs(delta) < MOBILE_HEADER_SCROLL.MIN_DELTA) return;

      if (scrollTop <= MOBILE_HEADER_SCROLL.TOP_OFFSET) {
        this.header.classList.remove('scrolled-past-header');
        this.showHeader(false, true);
        this.scrollDirection = 0;
        this.currentScrollTop = scrollTop;
        return;
      }

      const pastHeader = scrollTop > (this.headerBounds.bottom || this.header.offsetHeight);

      if (delta > 0) {
        this.scrollDirection = Math.max(0, this.scrollDirection) + delta;

        if (this.scrollDirection >= MOBILE_HEADER_SCROLL.DIRECTION_THRESHOLD && pastHeader) {
          this.header.classList.add('scrolled-past-header');
          this.hideHeader();
          this.scrollDirection = 0;
        }
      } else {
        this.scrollDirection = Math.min(0, this.scrollDirection) + delta;

        if (this.scrollDirection <= -MOBILE_HEADER_SCROLL.DIRECTION_THRESHOLD) {
          this.header.classList.add('scrolled-past-header');

          if (!this.preventReveal) {
            this.showHeader();
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 120);
          }

          this.scrollDirection = 0;
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hideHeader() {
      if (this.isHidden || this.isMenuDrawerOpen()) return;

      this.isHidden = true;
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'shopify-section-header-hidden');
      this.onHide();
    }

    showHeader(force = false, atTop = false) {
      if (!force && !this.isHidden && !atTop) return;

      this.isHidden = false;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.onShow(force, atTop);

      if (force && !this.mobileMediaQuery.matches) {
        this.header.classList.remove('animate');
      }
    }
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.mobileMediaQuery.addEventListener('change', this.onMobileMediaChange.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.hideHeaderOnScrollUp = () => {
        if (this.mobileHeaderHide) this.mobileHeaderHide.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.mobileHeaderHide = new MobileHeaderHideOnScroll(this.header, {
        getPredictiveSearches: () => this.predictiveSearches,
        onHide: () => {
          this.closeMenuDisclosure();
          this.closeSearchModal();
        },
        onShow: (force, atTop) => {
          if (atTop && !this.headerIsAlwaysSticky) {
            this.header.classList.remove('shopify-section-header-sticky');
          }
        },
      });
      this.mobileHeaderHide.connect(this);

      this.createObserver();
    }

    onMobileMediaChange() {
      this.mobileHeaderHide?.onMediaChange();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.mobileMediaQuery.removeEventListener('change', this.onMobileMediaChange);
      this.mobileHeaderHide?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.mobileHeaderHide?.showHeader(true);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelectorAll('.header-wrapper[data-section-id]').forEach((headerWrapper) => {
    if (headerWrapper.tagName === 'STICKY-HEADER' || headerWrapper.dataset.mobileHeaderHideInit) return;

    const header = headerWrapper.closest('.section-header');
    if (!header) return;

    headerWrapper.dataset.mobileHeaderHideInit = 'true';

    const mobileHeaderHide = new MobileHeaderHideOnScroll(header, {
      getPredictiveSearches: () => headerWrapper.querySelectorAll('predictive-search'),
    });
    mobileHeaderHide.connect(headerWrapper);
  });

  const hideHeaderFlagTooltip = (flagButton) => {
    flagButton.classList.remove('is-tooltip-visible');
    flagButton.setAttribute('aria-expanded', 'false');

    if (flagButton._tooltipTimeout) {
      clearTimeout(flagButton._tooltipTimeout);
      flagButton._tooltipTimeout = null;
    }
  };

  const showHeaderFlagTooltip = (flagButton) => {
    hideHeaderFlagTooltip(flagButton);
    flagButton.classList.add('is-tooltip-visible');
    flagButton.setAttribute('aria-expanded', 'true');
    flagButton._tooltipTimeout = setTimeout(() => {
      hideHeaderFlagTooltip(flagButton);
    }, 1500);
  };

  const initHeaderFlagTooltip = (scope = document) => {
    scope.querySelectorAll('.header__icon--flag:not([data-tooltip-init])').forEach((flagButton) => {
      flagButton.dataset.tooltipInit = 'true';

      flagButton.addEventListener('click', (event) => {
        event.stopPropagation();
        showHeaderFlagTooltip(flagButton);
      });
    });
  };

  initHeaderFlagTooltip();
  document.addEventListener('shopify:section:load', (event) => {
    initHeaderFlagTooltip(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
